export const EXTERNAL_LINKS_CAROUSEL_CONFIG = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 200,
    autoplay: false,
    arrows: true,
    margin: 10,
    slideBy: 1,
    autoWidth: true
};
